<template>
  <v-content>
    <v-container class="pa-0" style=" margin-left: auto; margin-right: auto; overflow:hidden;">
      <v-content class="pa-0">
        <v-card class="default-background">
          <v-img
                  src="images/teaser_home.jpg"
                  aspect-ratio="2.4"
          >
          </v-img>

          <v-card-text>
            <div class="headline">Testseite</div>
            <p class="subheading">
              Übertragung von Binärdaten innerhalb eines Json-Objektes via Post-Request.<br>
              Es wird ein SpecialSendService auf cleverads.de angesprochen.
            </p>
            <p>
                <v-btn block dark class="cta" @click="getPdfDocument">PDF erzeugen</v-btn>
              <v-btn block dark class="cta" @click="submitOfferRequestForSendService">JSON an SpecialSendService senden</v-btn>
            </p>
          </v-card-text>

        </v-card>
      </v-content>
    </v-container>
  </v-content>
</template>

<script>
  import PdfService from '../services/PdfService';

export default {
  name: "Test",
  components: {   },
  data: () => ({
    drawer: null,
    sendServiceRunning: false,
    checkServiceRunning: false,
    showErrorMessage: false,
    errorMessage: "",
  }),
  props: {
    source: String
  },
  mounted() {
    document.querySelector('#vier-gewinnt-app').style.maxWidth = this.$store.state.viewportWidth + 'px';
  },
  methods: {
    getPdfDocument(){
      this.$store.commit('work/IMPORT_CHECKSERVICE_RESPONSE',{
        policy: "987654321",
        polpr: "00009876543210000"
      });
      this.submitOfferRequestForDocumentService();
    },
    submitOfferRequestForDocumentService(){
      // Generiere die Police
      this.sendServiceRunning = true;
      let self = this;
      PdfService.generatePolicyDocument(this.$store.getters['work/getExportDataForDocumentService'])
              .then(function (response) {
                self.sendServiceRunning = false;
                var file = new Blob([response.data], {type: 'application/pdf'});
                // self.$store.commit("work/SET_POLICY_DOCUMENT",file);
                const reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = function () {
                  self.$store.commit("work/SET_POLICY_DOCUMENT", btoa(reader.result));
                  self.submitOfferRequestForSendService();
                }
              }).catch(function (response) {
        console.log("Der Aufruf des Pdf-Services hat nicht funktioniert und  liefert zurück:");
        self.sendServiceRunning = false;
        // Fehlermeldung für den Nutzer
        self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
        self.showErrorMessage = true;
      });
    },
    submitOfferRequestForSendService(){
      // Alle Daten an die Testschnittstelle übermitteln
      // Response auswerten. Wenn ok, dann:
      // Daten an /VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService übermitteln
      this.sendServiceRunning = true;
      let self = this;
      let test = this.$store.getters['work/getExportDataForSendService'];
      let testData = test.offerRequest.document.data.substring(0,100);
      console.log("Und in submitOfferRequestForSendService ist der Inhalt von testData: " + testData);
      PdfService.useSpecialSendService()
              .then(function (response) {
                self.sendServiceRunning = false;
                // console.log("Der Aufruf des Send-Services hat funktioniert. Response:");
                // console.dir(response);
                let answer = response.data;
                // Fehler meldet der SendService mit dem Array exceptions
                // console.log("answer enthält:");
                // console.dir(answer);
                if( (answer.result == "no" )){
                  // console.log("Der Send-Service antwortet mit exceptions.");
                  // Fehlerhandling
                  // TODO: Auswertung von messages.field und messages.type
                  self.errorMessage = answer.message;
                  self.showErrorMessage = true;
                }
                else {
                  console.log("Der Special-Send-Service antwortet mit result = " + answer.result);
                  // self.$store.dispatch("work/SET_CONTRACT_ACCEPTANCE_STATE");
                }
              }).catch(function (error) {
          console.log("Der Aufruf des Special-Send-Services hat nicht funktioniert und  liefert zurück:");
          console.dir(error);
          self.sendServiceRunning = false;
          // Fehlermeldung für den Nutzer
          self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
          self.showErrorMessage = true;
      });
    }
  }
};
</script>

<style scoped>
#vier-gewinnt-app {
  display: block;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}
.application {
  line-height: 1
}
.default-background {
  background-color: rgb(204, 213, 237) !important;
}
  .theme--light.v-navigation-drawer {
    background-color: #CCD5ED;
    color: #002EA7;
  }
.theme--light.v-icon {
    color: #002EA7;
  }
  div.v-toolbar__title {
    font-size: 24px;
  }
</style>
